import React from "react";
import "./beneficiaries-warning-modal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";

const AddBeneficiariesWarningModal = (props) => {
  return (
    <div className="beneficiaries-warning-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="warning-modal-body">
        <p className="heading">Adding a beneficiary</p>
        <p className="description">
          Your nominations will apply to your total pot unless you select an
          individual pot.
        </p>
        <Row>
          <Col xs={12} lg={6}>
            <Buttons
              name="Select an individual membership"
              className="tertiary mt-4"
              handleClick={props.onSelectHandler}
            />
          </Col>
          <Col xs={12} lg={6}>
            <Buttons
              name="Continue"
              className="primary mt-3"
              handleClick={props.onContinueHandler}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AddBeneficiariesWarningModal;
